<div class="form-section" [attr.data-section-id]="section.id" [attr.data-sort-index]="section.sortIndex">
	@for(group of section.groups; track group.id) {
		@if (viewModel.widgetGroups[group.id].enabled) {
			<div class="form-group" [formGroup]="viewModel.widgetGroups[group.id]" @enterLeave [@.disabled]="isReadOnly" [attr.data-group-id]="group.id" [attr.data-sort-index]="group.sortIndex">
				@for (widget of group.widgets; track widget.id) {
					@switch (widget.widgetType) {
						@case ('heading') {
							<app-heading background="secondary-2" size="small" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">{{ widget.metaData.label }}</app-heading>
						}
						@case ('text') {
							@if (widget.metaData.textMode === 'informative') {
								<app-informative [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">{{ widget.metaData.label }}</app-informative>
							}
							@else {
								<p class="form-control-label" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">{{ widget.metaData.label }}</p>
							}
						}
						@case ('text-input') {
							<app-text-input class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [placeholder]="widget.metaData.placeholder ?? ''"
											[inputMode]="widget.metaData.inputMode ?? 'text'" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-text-input>
						}
						@case ('text-area') {
							<app-textarea class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [hideLabel]="widget.metaData.hideLabel ?? false"
										[placeholder]="widget.metaData.placeholder ?? ''" [minRows]="widget.metaData.minimumRows ?? 1" debounce [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-textarea>
						}
						@case ('checkbox') {
							<app-checkbox class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-checkbox>
						}
						@case ('datetime') {
							<app-datetime class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''"
										[placeholder]="widget.metaData.placeholder ?? (widget.metaData.displayFormat ?? '')" [dateFormat]="widget.metaData.dateFormat ?? 'date'"
										[displayFormat]="widget.metaData.dateFormat === 'date-time' ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'"
										[formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-datetime>
						}
						@case ('select') {
							<app-select class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [placeholder]="widget.metaData.placeholder ?? ''"
										[items]="widget.metaData.items" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-select>
						}
						@case ('select-with-info') {
							<app-select-with-info class="validatable-group" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [hideLabel]="widget.metaData.hideLabel ?? false"
												[selectLabel]="widget.metaData.selectLabel ?? 'Response'" [selectPlaceholder]="widget.metaData.placeholder ?? ''"
												[selectItems]="widget.metaData.items" [infoLabel]="widget.metaData.infoLabel ?? 'Detail'"
												[infoPlaceholder]="widget.metaData.infoPlaceholder ?? ''" [infoIdentifiers]="widget.metaData.infoIdentifiers ?? []"
												[formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-select-with-info>
						}
						@case ('user-picker') {
							<app-user-picker class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [placeholder]="widget.metaData.placeholder ?? ''"
											[formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-user-picker>
						}
						@case ('user-signature') {
							<app-user-signature class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [alreadySignedMessage]="widget.metaData.alreadySignedMessage"
												[requireClinician]="true" [notClinicianMessage]="widget.metaData.invalidUserRoleMessage" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-user-signature>
						}
						@case ('service-picker') {
							<app-service-picker class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [placeholder]="widget.metaData.placeholder ?? ''"
												[formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-service-picker>
						}
						@case('complications-picker') {
							<app-complications-picker class="validatable-group" [readOnly]="isReadOnly" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-complications-picker>
						}
						@case ('multi-text-input') {
							<app-multi-text-input class="validatable-group" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [placeholder]="widget.metaData.placeholder ?? ''"
												[minItems]="widget.metaData.validators?.required ? 1 : 0" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-multi-text-input>
						}
						@case ('multi-checkbox') {
							<app-multi-checkbox class="validatable-group" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [subLabel]="widget.metaData.subLabel ?? ''"
												[items]="widget.metaData.items" [minItems]="widget.metaData.validators?.required ? 1 : 0" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-multi-checkbox>
						}
						@case ('multi-item-picker') {
							<app-multi-item-picker class="validatable-group" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [hideLabel]="widget.metaData.hideLabel ?? false" [items]="widget.metaData.items"
												[hideLabel]="widget.metaData.hideLabel ?? false" [minItems]="widget.metaData.validators?.required ? 1 : 0" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-multi-item-picker>
						}
						@case ('listy-picker') {
							<app-modality-body-parts-picker class="validatable-group" [readOnly]="isReadOnly" [modality]="widget.metaData.modality!" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-modality-body-parts-picker>
						}
						@case ('group-repeater') {
							<app-group-repeater [readOnly]="isReadOnly" [metaData]="widget.metaData" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex"></app-group-repeater>
						}
						@case ('radio-group') {
							<app-select class="validatable-control" [readOnly]="isReadOnly" [label]="widget.metaData.label ?? ''" [placeholder]="widget.metaData.placeholder ?? ''"
										[items]="widgetMetadataMapperService.mapRadioGroupOptionsToSelectItems(widget.metaData.options ?? [])" [formControl]="getWidgetControl(widget.id)" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex">
							</app-select>
						}
						@default {
							<div style="border: 1px solid red" [attr.data-widget-id]="widget.id" [attr.data-sort-index]="widget.sortIndex"><strong>{{ widget.widgetType }}</strong> not implemented<br/>{{ widget | json }} ({{widget.id}})</div>
						}
					}
				}
			</div>
		}
	}
</div>